import { render } from "./App.vue?vue&type=template&id=f9cd3fc6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=f9cd3fc6&lang=scss"

import exportComponent from "/home/runner/work/fernandonito/fernandonito/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__